module.exports = __webpack_public_path__ + "static/h3-a70358c35f17fc48af4c900e349bc0e9.png";